import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Autocomplete } from '@material-ui/lab';
import { Box, Card, CardContent, CardHeader, Container, Grid, IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography } from '@material-ui/core';
import Header from '../../components/Headers/Header';
import componentStyles from "../../assets/theme/views/admin/tables.js";
import { makeStyles } from "@material-ui/core/styles";
import { BACKEND_URL } from '../../env.js';
import { Add } from '@material-ui/icons';
import { Button } from 'antd';
import { toast } from 'react-toastify';
const useStyles = makeStyles(componentStyles);
const UserDetail = () => {
    const [users, setUsers] = useState([]);
    const [selectedEmail, setSelectedEmail] = useState('');
    const [orderData, setOrderData] = useState(null);
    const [invoice, setInvoices] = useState(null);
    const token = localStorage.getItem("Token");
    const [openModel, setOpenModel] = useState(false);
    const [invoiceData, setInvoiceData] = useState({
        return: '',
        total: '',
        status: ''
    });
    const statusOptions = ['paid', 'unpaid'];
    // Fetch all users
    useEffect(() => {
        axios.get(`${BACKEND_URL}/users`)
            .then(res => setUsers(res.data.users))
            .catch(err => console.error(err));
    }, []);
    const fetchInvoice = () => {
        axios.get(`${BACKEND_URL}/invoice/${selectedEmail}`, {
            headers: { token }
        })
            .then((res) => {
                setInvoices(res.data);
            })
            .catch(err => {
                console.error(err)
                setInvoices([])
            });
    }
    // Fetch order data of selected user
    useEffect(() => {
        if (selectedEmail) {
            axios.get(`${BACKEND_URL}/orders/user/${selectedEmail}`, {
                headers: { token }
            })
                .then(res => setOrderData(res.data))
                .catch(err => {
                    console.error(err)
                    setOrderData([])
                });
            fetchInvoice()
        }
    }, [selectedEmail]);
    // const getFilteredOrders = () => {
    //     const now = new Date();
    //     const currentYear = now.getFullYear();
    //     const currentMonth = now.getMonth(); // 0-based (0 = January, 11 = December)

    //     return orderData.filter(order => {
    //         const orderDate = new Date(order.orderDate);
    //         return orderDate.getFullYear() === currentYear && orderDate.getMonth() === currentMonth;
    //     });
    // };
    // Count order stats
    const getOrderCounts = () => {
        let completed = 0;
        let cancelled = 0;
        let inProcess = 0;
        let Ship = 0;
        let PaymentPending = 0;
        let PaymentPaid = 0;
        let PaymentReturn = 0;
        let totalProfitMargin = 0;
        let totalDeliveredAmount = 0;
        let totalCancelledAmount = 0;
        let totalPendingAmount = 0;
        let totalShipAmount = 0;
        let totalPaidAmount = 0;
        let totalUnPaidAmount = 0;
        // const filteredOrders = getFilteredOrders();
        orderData?.forEach(order => {
            // console.log(order.profitStatus === "returned");
            if (order.totalAmount) {
                totalProfitMargin += Number(order.totalAmount);
            }
            const orderTotal = Number(order.totalAmount) || 0;
            const profiteMargin = Number(order.profileMargin) || 0;
            if (order.status === 'delivered') {
                completed++;
                totalDeliveredAmount += orderTotal;
            } else if (order.status === 'cancelled') {
                cancelled++;
                totalCancelledAmount += orderTotal;
            } else if (order.status === 'pending') {
                inProcess++;
                totalPendingAmount += orderTotal;
            } else if (order.status === "shipped") {
                Ship++;
                totalShipAmount += orderTotal
            }
            if (order.profitStatus === 'pending') {
                PaymentPending++;
                totalUnPaidAmount += profiteMargin
            } else if (order.profitStatus === 'returned') {
                // console.log("hello");
                PaymentReturn++;
            } else if (order.profitStatus === 'payed') {
                PaymentPaid++;
                totalPaidAmount += profiteMargin
            }
        });

        return { completed, cancelled, inProcess, PaymentPending, PaymentReturn, PaymentPaid, totalProfitMargin, Ship, totalCancelledAmount, totalDeliveredAmount, totalPendingAmount, totalShipAmount, totalPaidAmount, totalUnPaidAmount };
    };

    const { completed, cancelled, inProcess, PaymentPaid, PaymentPending, PaymentReturn, totalProfitMargin, Ship, totalCancelledAmount, totalDeliveredAmount, totalShipAmount, totalPendingAmount, totalUnPaidAmount, totalPaidAmount } = getOrderCounts();


    // Labels for each card
    const cardData = [
        { label: 'Order Delivered', key: 'completed' },
        { label: 'Order Cancelled', key: 'cancelled' },
        { label: 'Order In Process', key: 'inProcess' },
        { label: 'Paid Payment', key: 'PaymentPaid' },
        { label: 'Pending Payment', key: 'PaymentPending' },
        { label: 'Returned Payment', key: 'PaymentReturn' },
        { label: 'Total Profit Margin', key: 'totalProfitMargin' }
    ];
    const classes = useStyles();
    const handleChange = (e) => {
        const { name, value } = e.target;
        setInvoiceData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleCreateInvoice = async () => {
        try {
            await axios.post(`${BACKEND_URL}/invoice/`, { returnCharges: invoiceData.return, totalPayout: invoiceData.total, status: invoiceData.status, email: selectedEmail }, {
                headers: { token }
            });
            setOpenModel(false);
            setInvoiceData({ return: '', total: '', status: '' });
            toast.success('Invoice created successfully!');
            fetchInvoice()
        } catch (err) {
            console.error(err);
            toast.error('Failed to create invoice.');
        }
    };
    const handleUpdateInvoice = async (invoiceId, updatedData) => {
        try {
            await axios.put(`${BACKEND_URL}/invoice/${invoiceId}`, {
                returnCharges: updatedData.returnCharges,
                totalPayout: updatedData.totalPayout,
                status: updatedData.status,
                email: updatedData.email
            }, {
                headers: { token }
            });

            toast.success('Invoice updated successfully!');

            // Optionally update state locally
            setInvoices((prev) =>
                prev.map((inv) =>
                    inv.id === invoiceId ? { ...inv, ...updatedData } : inv
                )
            );
        } catch (error) {
            console.error(error);
            toast.error('Failed to update invoice.');
        }
    };


    return (
        <>
            <Header />
            <Container
                maxWidth={false}
                component={Box}
                marginTop="-6rem"
                classes={{ root: classes.containerRoot }}
            >
                <Box style={{ padding: 32, marginTop: "100px" }}>
                    <Autocomplete
                        options={users}
                        getOptionLabel={(option) => option.email || ''}
                        onChange={(e, value) => setSelectedEmail(value?.email || '')}
                        renderInput={(params) => <TextField {...params} label="Select User" variant="outlined" />}
                        style={{ marginBottom: 32, width: 300 }}
                    />

                    {orderData && (
                        <Grid container spacing={2}>
                            {/* {cardData.map(({ label, key }) => (
                        <Grid item xs={12} sm={6} md={4} key={key}>
                            <Card elevation={3}>
                                <CardContent>
                                    <Typography variant="subtitle1">{label}</Typography>
                                    <Typography variant="h6" color="primary">
                                        {(() => {
                                            switch (key) {
                                                case 'completed': return completed;
                                                case 'cancelled': return cancelled;
                                                case 'inProcess': return inProcess;
                                                case 'PaymentPaid': return PaymentPaid;
                                                case 'PaymentPending': return PaymentPending;
                                                case 'PaymentReturn': return PaymentReturn;
                                                case 'totalProfitMargin': return totalProfitMargin;
                                                default: return 0;
                                            }
                                        })()}
                                    </Typography>
                                </CardContent>
                            </Card>
                        </Grid>
                    ))} */}
                            <Grid item xs={12} sm={6} md={4} >
                                <Card elevation={3}>
                                    <CardContent>
                                        <Typography variant="subtitle1">Order Delivered</Typography>
                                        <Typography variant="h6" color="primary">
                                            AED {totalDeliveredAmount}
                                        </Typography>
                                        <Typography variant="h6" color="primary">
                                            {completed} (Order)
                                        </Typography>
                                    </CardContent>
                                </Card>
                            </Grid>
                            <Grid item xs={12} sm={6} md={4} >
                                <Card elevation={3}>
                                    <CardContent>
                                        <Typography variant="subtitle1">Order Returned</Typography>
                                        <Typography variant="h6" color="primary">
                                            AED -{cancelled * 5}
                                        </Typography>
                                        <Typography variant="h6" color="primary">
                                            {cancelled} (Order)
                                        </Typography>
                                    </CardContent>
                                </Card>
                            </Grid>
                            <Grid item xs={12} sm={6} md={4} >
                                <Card elevation={3}>
                                    <CardContent>
                                        <Typography variant="subtitle1">Order Pending</Typography>
                                        <Typography variant="h6" color="primary">
                                            AED  {totalPendingAmount}
                                        </Typography>
                                        <Typography variant="h6" color="primary">
                                            {inProcess} (Order)
                                        </Typography>
                                    </CardContent>
                                </Card>
                            </Grid>
                            <Grid item xs={12} sm={6} md={4} >
                                <Card elevation={3}>
                                    <CardContent>
                                        <Typography variant="subtitle1">Order Dispatch</Typography>
                                        <Typography variant="h6" color="primary">
                                            AED  {totalShipAmount}
                                        </Typography>
                                        <Typography variant="h6" color="primary">
                                            {Ship} (Order)
                                        </Typography>
                                    </CardContent>
                                </Card>
                            </Grid>
                            <Grid item xs={12} sm={6} md={4} >
                                <Card elevation={3}>
                                    <CardContent>
                                        <Typography variant="subtitle1">Paid Amount</Typography>
                                        <Typography variant="h6" color="primary">
                                            AED {totalPaidAmount}
                                        </Typography>
                                        <Typography variant="h6" color="primary">
                                            {PaymentPaid} (Order)
                                        </Typography>
                                    </CardContent>
                                </Card>
                            </Grid>
                            <Grid item xs={12} sm={6} md={4} >
                                <Card elevation={3}>
                                    <CardContent>
                                        <Typography variant="subtitle1">UnPaid Amount</Typography>
                                        <Typography variant="h6" color="primary">
                                            AED {totalUnPaidAmount}
                                        </Typography>
                                        <Typography variant="h6" color="primary">
                                            {PaymentPending} (Order)
                                        </Typography>
                                    </CardContent>
                                </Card>
                            </Grid>
                            <Grid item xs={12} sm={6} md={4} >
                                <Card elevation={3}>
                                    <CardContent>
                                        <Typography variant="subtitle1">Total Amount</Typography>
                                        <Typography variant="h6" color="primary">
                                            AED {totalProfitMargin}
                                        </Typography>
                                    </CardContent>
                                </Card>
                            </Grid>
                        </Grid>
                    )}
                </Box>
                <Card classes={{ root: classes.cardRoot }}>
                    <CardHeader
                        className={classes.cardHeader}
                        title="Invoice"
                        titleTypographyProps={{
                            component: Box,
                            marginBottom: "0!important",
                            variant: "h3"
                        }}
                        action={
                            <Box display="flex" alignItems="center">
                                <Button onClick={() => setOpenModel(!openModel)} variant="outlined" style={{ marginLeft: "10px" }} onClick={() => setOpenModel(!openModel)}>
                                    Create Invoice
                                </Button>
                            </Box>
                        }
                    ></CardHeader>
                    {invoice?.length >= 1 ? (
                        <TableContainer>
                            <Box component={Table} alignItems="center" marginBottom="0!important">
                                <TableHead>
                                    <TableRow>
                                        <TableCell
                                            classes={{
                                                root: classes.tableCellRoot + " " + classes.tableCellRootHead
                                            }}
                                        >Invoice Number</TableCell>
                                        <TableCell
                                            classes={{
                                                root: classes.tableCellRoot + " " + classes.tableCellRootHead
                                            }}
                                        >Date</TableCell>
                                        <TableCell
                                            classes={{
                                                root: classes.tableCellRoot + " " + classes.tableCellRootHead
                                            }}
                                        >Return</TableCell>
                                        <TableCell
                                            classes={{
                                                root: classes.tableCellRoot + " " + classes.tableCellRootHead
                                            }}
                                        >Total Payout</TableCell>
                                        <TableCell
                                            classes={{
                                                root: classes.tableCellRoot + " " + classes.tableCellRootHead
                                            }}
                                        >Invoice Total</TableCell>
                                        <TableCell
                                            classes={{
                                                root: classes.tableCellRoot + " " + classes.tableCellRootHead
                                            }}
                                        >Status</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {invoice?.map((inv) => {
                                        return (<TableRow key={inv?.id}>
                                            <TableCell classes={{ root: classes.tableCellRoot }}>
                                                {inv?.id || 0}
                                            </TableCell>
                                            <TableCell classes={{ root: classes.tableCellRoot }}>
                                                {new Date(inv.createdAt).toLocaleString('en-GB', {
                                                    year: 'numeric',
                                                    month: 'short',
                                                    day: 'numeric',
                                                    hour: '2-digit',
                                                    minute: '2-digit',
                                                    second: '2-digit',
                                                })
                                                }
                                            </TableCell>
                                            <TableCell classes={{ root: classes.tableCellRoot }}>
                                                {inv?.returnCharges || 0}
                                            </TableCell>
                                            <TableCell classes={{ root: classes.tableCellRoot }}>
                                                {inv?.totalPayout || 0}
                                            </TableCell>
                                            <TableCell classes={{ root: classes.tableCellRoot }}>
                                                {Number(inv.totalPayout) + Number(inv.returnCharges) || 0}
                                            </TableCell>
                                            <TableCell classes={{ root: classes.tableCellRoot }}>
                                                <TextField
                                                    select
                                                    value={inv.status}
                                                    onChange={(e) =>
                                                        handleUpdateInvoice(inv.id, {
                                                            ...inv,
                                                            status: e.target.value
                                                        })
                                                    }
                                                    SelectProps={{
                                                        native: true,
                                                    }}
                                                    variant="outlined"
                                                    size="small"
                                                >
                                                    <option value="paid">paid</option>
                                                    <option value="unpaid">unpaid</option>
                                                </TextField>
                                            </TableCell>
                                        </TableRow>)
                                    })}
                                </TableBody>
                            </Box>
                        </TableContainer>
                    ) : null}
                </Card>
                {openModel && (
                    <Box
                        position="fixed"
                        top={0}
                        left={0}
                        width="100%"
                        height="100%"
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                        bgcolor="rgba(0,0,0,0.3)"
                        zIndex={9999}
                    >
                        <Card style={{ padding: 20, width: 400 }}>
                            <Typography variant="h5" gutterBottom>Create Invoice</Typography>

                            <TextField
                                fullWidth
                                label="Return"
                                name="return"
                                value={invoiceData.return}
                                onChange={handleChange}
                                margin="normal"
                                variant="outlined"
                            />

                            <TextField
                                fullWidth
                                label="Total"
                                name="total"
                                value={invoiceData.total}
                                onChange={handleChange}
                                margin="normal"
                                variant="outlined"
                            />

                            <TextField
                                fullWidth
                                select
                                SelectProps={{ native: true }}
                                // label="Status"
                                name="status"
                                value={invoiceData.status}
                                onChange={handleChange}
                                margin="normal"
                                variant="outlined"
                            >
                                <option value="">Select Status</option>
                                <option value="paid">Paid</option>
                                <option value="unpaid">UnPaid</option>
                            </TextField>

                            <Box mt={2} display="flex" justifyContent="space-between">
                                <Button onClick={handleCreateInvoice} type="primary">
                                    Submit
                                </Button>
                                <Button onClick={() => setOpenModel(false)} type="default">
                                    Cancel
                                </Button>
                            </Box>
                        </Card>
                    </Box>
                )}

            </Container>
        </>
    );
};

export default UserDetail;
